import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { USERS_I_CAN_SEE_ADMIN, USERS_I_CAN_SEE_USER } from './SecurityRules';

export interface AddressRow {
  id: number;
  line_one: string | null;
  line_two: string | null;
  postcode: string | null;
  city: string | null;
  county: string | null;
  country: string | null;
}

export const Address: Entity<AddressRow> = {
  id: 'Address',
  title: 'Address',
  pluralTitle: 'Addresses',
  service: 'main',
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.address',
  },
  rowLabel: (row: AddressRow) => {
    const parts = [row.line_one, row.city, row.postcode].filter(Boolean);
    return parts.join(', ') || `Address ${row.id}`;
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: 'id IN (SELECT address_id FROM public.user_view WHERE id IN ' + USERS_I_CAN_SEE_USER + ')',
    },
    {
      role: 'admin',
      action: 'read',
      access: 'conditional',
      condition: 'id IN (SELECT address_id FROM public.user_view WHERE id IN ' + USERS_I_CAN_SEE_ADMIN + ')',
    },
    {
      role: 'staff',
      action: 'all',
      access: 'all',
    },
  ],
  defaultSort: [['id', 'DESC']],
  fields: {
    id: {
      seq: 100,
      type: FieldType.Integer,
      label: 'ID',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    line_one: {
      seq: 110,
      type: FieldType.Text,
      label: 'Address Line 1',
      fieldGroup: 'address',
      listColumn: true,
      maxLength: 255,
    },
    line_two: {
      seq: 120,
      type: FieldType.Text,
      label: 'Address Line 2',
      fieldGroup: 'address',
      maxLength: 255,
    },
    postcode: {
      seq: 130,
      type: FieldType.Text,
      label: 'Postcode',
      fieldGroup: 'address',
      listColumn: true,
      maxLength: 255,
    },
    city: {
      seq: 140,
      type: FieldType.Text,
      label: 'City',
      fieldGroup: 'address',
      listColumn: true,
      maxLength: 255,
    },
    county: {
      seq: 150,
      type: FieldType.Text,
      label: 'County',
      fieldGroup: 'address',
      maxLength: 255,
    },
    country: {
      seq: 160,
      type: FieldType.Text,
      label: 'Country',
      fieldGroup: 'address',
      listColumn: true,
      maxLength: 255,
    },
  },
};
